class AddressList {
    id: number;
    name: string;
    description: string;
    connectionString: string;
    sqlStatement: string;
    mappingFilters: Array<AddressMappingFilter>;
    organisationId: number;
    companyId: number;

    constructor(data) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.description = data?.description ?? "";
        this.connectionString = data?.connectionString ?? "";
        this.sqlStatement = data?.sqlStatement ?? "";
        this.mappingFilters = data?.mappingFilters ? createInstances(AddressMappingFilter, data.mappingFilters as Array<any>) : [];

        this.organisationId = data?.organisationId ?? 0;
        this.companyId = data?.companyId ?? 0;
    }

    getFilterId(mappingId: number) {
        return this.mappingFilters.find(x => x.mapping == mappingId)?.filter;
    }

    hasMapping(mappingId: number) {
        return this.mappingFilters.find(x => x.mapping == mappingId) !== undefined;
    }

    validCompany(companyId: number) {
        if (irSettings.multiTenant) {
            if (this.organisationId == 0 || this.organisationId === null)
                return true;

            var company = CompanyService.getCompany(companyId);
            if (!company) {
                return false;
            }

            if (this.organisationId == company.organisationId && (this.companyId === 0 || this.companyId === null)) {
                return true;
            }

            return this.companyId == companyId;
        }

        return true;
    }

    validMapping(mappingId: number) {
        return this.mappingFilters.length === 0 || this.mappingFilters.filter(x => x.mapping == mappingId).length > 0;
    }
}